const PULSE = 'animation: markerPulse 1.5s infinite ease-in-out;';

const BUSY_TRIP_MARKER_CAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>`;

function wrap(html, width, height) {
  return { html, width, height };
}

function numberedCircle(number, color, extra = '', pulse = false) {
  const anim = pulse ? PULSE : '';
  return wrap(
    `<div style="${anim}background:${color};color:white;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:12px;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.3);">${number}${extra}</div>`,
    28,
    28
  );
}

export function buildDriverMarkerHtml(isBusy = false, profileImageURL = '', pulse = false) {
  const markerSize = isBusy ? 44 : 40;
  const backgroundColor = isBusy ? 'linear-gradient(135deg, #F59E0B, #D97706)' : '#3B82F6';
  const animation = isBusy
    ? 'animation: pulse 2s infinite;'
    : pulse
      ? 'animation: markerPulse 1.5s infinite ease-in-out;'
      : '';
  const content = profileImageURL
    ? `<img src="${profileImageURL}" alt="Driver" style="width:${markerSize - 8}px;height:${markerSize - 8}px;border-radius:50%;object-fit:cover;border:2px solid white;" onerror="this.style.display='none';this.parentElement.innerHTML='<span style=color:white;font-weight:bold;font-size:16px>D</span>'">`
    : `<span style="color:white;font-weight:bold;font-size:16px;">D</span>`;

  const html = `<div style="${animation}background:${backgroundColor};width:${markerSize}px;height:${markerSize}px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid white;box-shadow:0 3px 10px rgba(59,130,246,0.5);">${content}</div>`;
  return wrap(html, markerSize, markerSize);
}

export function buildPickupMarkerHtml(number, color = '#22C55E', pulse = false) {
  return numberedCircle(number, color, '', pulse);
}

export function buildDropoffMarkerHtml(number, color = '#EF4444', pulse = false) {
  return numberedCircle(number, color, '', pulse);
}

export function buildBusyPickupMarkerHtml(number, color = '#F59E0B', pulse = false) {
  const anim = pulse ? PULSE : '';
  return wrap(
    `<div style="${anim}background:linear-gradient(135deg,${color},${color});color:white;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:10px;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.3);">${BUSY_TRIP_MARKER_CAR_SVG}${number}</div>`,
    28,
    28
  );
}

export function buildBusyDropoffMarkerHtml(number, color = '#EF4444', pulse = false) {
  return buildBusyPickupMarkerHtml(number, color, pulse);
}

export function buildCombinedMarkerHtml(dropoffNum, pickupNum, driverColor = '#22C55E', pulse = false) {
  const anim = pulse ? PULSE : '';
  return wrap(
    `<div style="${anim}display:flex;flex-direction:column;align-items:center;">
      <div style="background:${driverColor};color:white;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:10px;border:2px solid white;margin-bottom:-6px;z-index:2;">${dropoffNum}</div>
      <div style="background:${driverColor};color:white;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:10px;border:2px solid white;z-index:1;">${pickupNum}</div>
    </div>`,
    22,
    48
  );
}

export function buildMarkerHtml(marker, options = {}) {
  const {
    selectedTripId = null,
    pulsate = false,
    pickupColor = '#22C55E',
    dropoffColor = '#EF4444',
  } = options;

  const isMarkerForSelectedTrip =
    selectedTripId &&
    (marker.tripId === selectedTripId || marker.nextPickupTripId === selectedTripId);
  const pulse = pulsate || isMarkerForSelectedTrip;
  const driverColor = marker.driverColor;

  if (marker.type === 'driver') {
    return buildDriverMarkerHtml(marker.isBusy, marker.profileImageURL, pulsate);
  }
  if (marker.type === 'combined') {
    return buildCombinedMarkerHtml(
      marker.tripNumber,
      marker.nextPickupNumber,
      driverColor || pickupColor,
      pulse
    );
  }
  if (marker.type === 'pickup') {
    const color = driverColor || pickupColor;
    return marker.isBusyTrip
      ? buildBusyPickupMarkerHtml(marker.tripNumber, color, pulse)
      : buildPickupMarkerHtml(marker.tripNumber, color, pulse);
  }
  const color = driverColor || dropoffColor;
  return marker.isBusyTrip
    ? buildBusyDropoffMarkerHtml(marker.tripNumber, color, pulse)
    : buildDropoffMarkerHtml(marker.tripNumber, color, pulse);
}

export function formatTripStatus(status) {
  if (!status) return '';
  const s = status.toLowerCase();
  if (s === 'arrived') return 'On Scene';
  if (s === 'started') return 'Member Onboard';
  if (s === 'onway') return 'Onway';
  return status;
}
